import React, { useEffect, useState } from 'react'
import { ReactSVG } from 'react-svg';
import WizardButton from '../../wizard-v2/components/WizardButton'
import { t } from '../../../utilities/translator';
import { getWizardV2State } from '../../wizard-v2/wizardService';
import { createPortal } from 'react-dom';

const WhoStepDesktop = ({
  form,
  onCardClick,
  showCapacityTotalButton,
  handleChangeCapacityClick,
  onContinueClick,
}) => {
  const [footerElement, setFooterElement] = useState(null);
  const data = getWizardV2State().whoStep;

  useEffect(() => {
    const footer = document.getElementById('wizard-next-button');
    if (footer) {
      setFooterElement(footer);
    }

    // eslint-disable-next-line no-undef
    if (window.location.search.indexOf('wizardWidget=true') > -1 && typeof Didomi !== 'undefined' && typeof Didomi.getUserStatus === 'function') {
      // Hide cookie consent popup if wizardWidget=true in the url (wizard for iframe)
      // eslint-disable-next-line no-undef
      if (!Didomi.getUserStatus().consent_string && typeof Didomi.notice !== 'undefined') {
        // eslint-disable-next-line no-undef
        Didomi.notice.hide();
      }
    }
  }, []);

  const preSelectionComponent = () => {
    const adultsLabel = form.who.capacity?.adults === 1
      ? data.preselectAdult
      : data.preselectAdults.replace('%adults%', form.who.capacity?.adults);

    const selectedCapacity = data.items.find(item => item.id === 'family');
    let capacityText = adultsLabel;
    if (form.who.capacity?.children > 0) {
      capacityText += `, ${form.who.capacity.children} ${t('general.children_plural', { count: form.who.capacity.children })} (${form.who.capacity.childAges.join(', ')})`;
    }

    return (
      <div className="wizard-capacity-filled">
        <span className="wizard-capacity-label">{data.preselectText}</span>
        <div className="wizard-capacity-preselection">
          <div className="flex flex-col items-center gap-1">
            <ReactSVG src={selectedCapacity.img} />
            <span className="capacity-label">{selectedCapacity.text}</span>
          </div>

          <div className="capacity-text">
            {capacityText}
          </div>

          <button className="capacity-change-button" onClick={handleChangeCapacityClick}>{data.preselectButtonText}</button>
        </div>
      </div>
    )
  }

  return (
    <div className="who-step">
      <p className="mb-8 heading-large text-primary">{data.titleText}</p>
      <div className="flex gap-6 justify-center mb-8">
        {showCapacityTotalButton ? preSelectionComponent() : (
          data.items.map((item, index) => (
            <WizardButton
              key={index}
              label={item.text}
              iconUrl={item.img}
              className={`px-9 py-6 w-auto slide-in-bottom animation-delay-${index * 100}`}
              active={form.who?.id === item.id}
              onClick={onCardClick(item)}
            />
          ))
        )}
      </div>
      {footerElement && createPortal(
        <button className="wizard-btn wizard-btn--next" disabled={!form.who?.id} onClick={onContinueClick}>
          {data.buttonText}
          <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
        </button>,
        footerElement)}
    </div>
  )
}

export default WhoStepDesktop
